import React, { ReactNode } from 'react';
import { Mentions } from 'antd';
import { MentionsOptionProps as MentionsOptionCpyProps } from 'antd/lib/mentions';

export type MentionsOptionProps = MentionsOptionCpyProps & {
  children?: ReactNode;
}

const ProMentionsOption: React.FC<MentionsOptionProps> = (props) => {
  const { children, ...resProps } = props;

  return <Mentions.Option {...resProps}>{children}</Mentions.Option>;
};

export default ProMentionsOption;
